import React, { useState } from "react";
import "./Masonry.css";
import { Image, ImageViewer } from "../../ui";

const Masonry = ({
  images,
  orientation = "horizontal",
  imageViewer = true,
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleImageClick = (index) => {
    setActiveIndex(index);
    setIsViewerOpen(true);
  };
  return (
    <div className={`Masonry ${orientation}`}>
      <div class="masonry">
        {images.map((img, index) => (
          <div class="brick">
            <Image
              key={index}
              src={img}
              alt="masonry-img"
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>
      {imageViewer && isViewerOpen && (
        <ImageViewer
          images={images}
          index={activeIndex}
          closeViewer={() => setIsViewerOpen(false)}
        />
      )}
    </div>
  );
};

export default Masonry;
